const SurveyContainer = ({ children, title }) => {
  return (
    <div className="background-color-w">
      <div className="base-sec-top flex">
        <div>
          <p className='title'>{title}</p>
        </div>
      </div>
      {children}
    </div>
  );
};

export default SurveyContainer;
